import { BehaviorSubject } from 'rxjs';
import { TSTreeNode } from 'tsui';
import { NewPermission } from '@core/enums';
import { ReportTypeQueryParamValues } from 'app/modules/reports/reports.types';

/** Query param values for `?type=` on `/reporting/list`. */
export type ReportingListTypeFilter = 'builder' | 'pdf';

export const REPORTING_LIST_TYPE_QUERY_PARAM = 'type';

export const ALL_REPORT_TYPE_QUERY_VALUES: ReportTypeQueryParamValues[] = [
  ReportTypeQueryParamValues.Legacy,
  ReportTypeQueryParamValues.SingleObject,
  ReportTypeQueryParamValues.TimeSeries,
];

export const BUILDER_REPORT_TYPE_QUERY_VALUES: ReportTypeQueryParamValues[] = [
  ReportTypeQueryParamValues.SingleObject,
  ReportTypeQueryParamValues.TimeSeries,
];

export const PDF_REPORT_TYPE_QUERY_VALUES: ReportTypeQueryParamValues[] = [ReportTypeQueryParamValues.Legacy];

/** Any of these grants access to Report Builder list filters / rows. */
export const REPORT_BUILDER_ACCESS_PERMISSIONS = [
  NewPermission.REPORTS_BUILDER_VIEW,
  NewPermission.REPORTS_BUILDER_EDIT,
  NewPermission.REPORTS_BUILDER_DELETE,
  NewPermission.REPORT_BUILDER_CREATE,
  NewPermission.REPORT_BUILDER_SHARING_RECORDS,
] as const;

/** Any of these grants access to PDF Reports list filters / rows. */
export const PDF_REPORTS_ACCESS_PERMISSIONS = [
  NewPermission.PDF_REPORTS_VIEW,
  NewPermission.PDF_REPORTS_EDIT,
  NewPermission.PDF_REPORTS_DELETE,
  NewPermission.PDF_REPORTS_CREATE,
  NewPermission.PDF_REPORTS_SHARING_RECORDS,
] as const;

export const resolveReportTypesFromQueryParam = (type: string | null | undefined): ReportTypeQueryParamValues[] => {
  if (type === 'builder') {
    return BUILDER_REPORT_TYPE_QUERY_VALUES;
  }

  if (type === 'pdf') {
    return PDF_REPORT_TYPE_QUERY_VALUES;
  }

  return ALL_REPORT_TYPE_QUERY_VALUES;
};

/** Intersects the view filter with products the user can actually access. */
export const resolveAccessibleReportTypes = (
  type: string | null | undefined,
  access: { builder: boolean; pdf: boolean },
): ReportTypeQueryParamValues[] => {
  const requested = resolveReportTypesFromQueryParam(type);

  return requested.filter((reportType) => {
    if (reportType === ReportTypeQueryParamValues.Legacy) {
      return access.pdf;
    }

    return access.builder;
  });
};

export const reportBuilderListMenuItems = new BehaviorSubject<TSTreeNode[]>([
  {
    id: 'all-reports',
    name: 'All Reports',
    expandable: false,
    icon: 'view_list',
    link: 'reporting/list',
    badge: {
      value: '0',
      type: 'transparent',
    },
  },
  {
    id: 'report-builder',
    name: 'Report Builder',
    expandable: false,
    icon: 'view_list',
    link: 'reporting/list?type=builder',
    badge: {
      value: '',
      type: 'transparent',
    },
  },
  {
    id: 'pdf-reports',
    name: 'PDF Reports',
    expandable: false,
    icon: 'picture_as_pdf',
    link: 'reporting/list?type=pdf',
    badge: {
      value: '',
      type: 'transparent',
    },
  },
  {
    id: 'created_by_me',
    name: 'Created By Me',
    expandable: false,
    icon: 'view_list',
    link: 'reporting/list?byme=true',
    badge: {
      value: '',
      type: 'transparent',
    },
  },
  {
    id: 'favorites',
    name: 'Favorites',
    expandable: false,
    icon: 'star_border',
    link: 'reporting/list?favorites=true',
    badge: {
      value: '',
      type: 'transparent',
    },
  },
]);
